import styled from 'styled-components';
import { theme, toRem } from '../../styles';
import { colors } from '../../styles/colors';

export const StyledSubmitContainer = styled.div`
  .accordion {
    background: #fff;
    margin-bottom: 12px;
    border: 1px solid ${colors.darkgrey};
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 16px;
    }
  }
  .accordion__container .accordion__list {
    border-top: 1px solid ${colors.darkgrey};
    padding: 0 15px;
    margin-top: 0px;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 0 5px 0px 15px;
    }
  }

  .accordion__title {
    padding-left: 10px;
    margin: 1rem 0 !important;
    font: normal normal var(--t-title-m-font-weight) ${toRem(18)} / ${toRem(16)} var(--t-base-font-family);
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      margin: 0.5rem 0 !important;
    }
  }
  .accordion__title > span {
    padding-right: 20px;
  }
  .edit__text {
    button {
      font: normal normal 700 ${toRem(10)} / ${toRem(20)} var(--t-base-font-family) !important;
      position: absolute;
      top: 16px;
      right: -9px;
      background: transparent;
      color: var(--t-interactive-accent-color);
      @media ${theme.mediaQuery.allMobiles} {
        top: 9px;
        right: 5px;
      }
    }
  }

  .deptText {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 3px !important;
    }
  }

  .container1 {
    margin-right: 75px !important;
  }

  .dropdown-box {
    padding: 24px 22px 24px 0px;
    font-size: 12px;
    line-height: 16px;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 12px 38px 12px 0px;
      font-size: 10px;
    }
    div {
      margin-bottom: 3px;
    }
  }
  .icon-arrow-up,
  .icon-arrow-down {
    &:before {
      font-size: 1.25rem !important;
      color: ${colors.grey4};
      position: relative;
      right: 10px;
      top: 4px;
    }
  }

  .icon-arrow-up {
    &:before {
      top: 2px;
    }
  }

  .d-flex-row {
    @media ${theme.mediaQuery.allMobiles} {
      flex-direction: column !important;
    }
  }

  p {
    &.bold {
      font-weight: 700 !important;
    }
  }

  p,
  div {
    &.t-font-m {
      font: normal normal var(--t-title-m-font-weight) 1rem/1.5rem var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family);
      }
    }
    &.t-font-s {
      font: normal normal var(--t-title-m-font-weight) 1rem/1.5rem var(--t-base-font-family);
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(16)} var(--t-base-font-family);
        line-height: 20px;
      }
    }
  }

  h1 {
    font: normal normal var(--t-title-m-font-weight) ${toRem(60)} / normal var(--t-title-font-family);
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(30)} / normal var(--t-title-font-family);
      margin-bottom: 16px;
    }
  }

  .subtext {
    margin-bottom: 0px;
    p {
      margin-bottom: 20px !important;
      @media ${theme.mediaQuery.allMobiles} {
        margin-bottom: 8px !important;
      }
    }
  }
  p {
    &.hotel-name {
      font-weight: 700;
      margin-bottom: 12px !important;
      @media ${theme.mediaQuery.allMobiles} {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 16px !important;
      }
    }
  }

  .d-flex-mobile {
    @media ${theme.mediaQuery.allMobiles} {
      justify-content: space-between !important;
    }
    button {
      font-weight: 400;
      @media ${theme.mediaQuery.allMobiles} {
        padding: 7px 28px;
      }
      &.m-button-primary {
        @media ${theme.mediaQuery.allMobiles} {
          padding: 8px 28px;
        }
      }
    }
  }
  .lr-no-padding {
    padding: 48px 17px !important;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 28px 5px !important;
    }
  }
  .privacytext {
    font-weight: 400 !important;
    margin-bottom: 20px !important;
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 8px !important;
    }
    a {
      text-decoration: underline !important;
      font-weight: 400 !important;
    }
  }

  .d-item-container {
    &.ml-3 {
      margin-left: 70px !important;
      @media ${theme.mediaQuery.allMobiles} {
        margin-left: 15px !important;
      }
    }
  }

  .btn-wrappper {
    button[aria-label='Submit'] {
      width: 145px;
      padding: 9px 24px !important;
      font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family) !important;
        width: 110px;
        height: auto;
        padding: 7px 24px 8px !important;
      }
    }

    button[aria-label='Previous'] {
      width: 145px;
      padding: 8px 24px !important;
      font: normal normal 700 ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal 700 ${toRem(13)} / ${toRem(17)} var(--t-base-font-family) !important;
        width: 110px;
        height: auto;
        padding: 7px 24px 6px !important;
      }
    }
  }
  .trip-contact-preference {
    display: inline;
  }
  .trip-contact-preference div {
    display: block;
  }
`;

export const StyledModalSection = styled.div`
  .prearrival-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(5px);
  }
  .dining-request-modal {
    background-color: ${colors.white};
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    max-width: 596px;
    padding: 53px 71px 49px !important;
    position: relative;
    z-index: 10000; /* Ensure the modal is on top of the overlay */
    margin: 0 auto;
    @media ${theme.mediaQuery.allMobiles} {
      max-width: 330px;
      border-radius: 8px;
      padding: 66px 32px 35px !important;
    }
  }
  .close-button-container {
    position: absolute;
    top: -30px;
    right: -30px;
  }
`;
